/* tslint:disable */
/* eslint-disable */
/**
 * Notes API
 * API for managing notes with tags, mentions and attachments
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Dossier (risque assuré) auquel la note est rattachée
 * @export
 * @interface RiskNoteMinimalDto
 */
export interface RiskNoteMinimalDto {
    /**
     * Id du risque assuré (riskId) — navigation vers le dossier
     * @type {string}
     * @memberof RiskNoteMinimalDto
     */
    id?: string;
    /**
     * Identifiant lisible du dossier
     * @type {string}
     * @memberof RiskNoteMinimalDto
     */
    identifier?: string;
    /**
     * Statut lisible du dossier
     * @type {string}
     * @memberof RiskNoteMinimalDto
     */
    status?: string | null;
    /**
     * Code branche du dossier
     * @type {string}
     * @memberof RiskNoteMinimalDto
     */
    type?: string | null;
    /**
     * Id du contrat quand le dossier a un contrat (actif/signé) : navigation directe vers la page contrat (/mes-contrats/details/{contractId}) au lieu des étapes de contractualisation. Absent sinon.
     * 
     * @type {string}
     * @memberof RiskNoteMinimalDto
     */
    contractId?: string | null;
}

/**
 * Check if a given object implements the RiskNoteMinimalDto interface.
 */
export function instanceOfRiskNoteMinimalDto(value: object): value is RiskNoteMinimalDto {
    return true;
}

export function RiskNoteMinimalDtoFromJSON(json: any): RiskNoteMinimalDto {
    return RiskNoteMinimalDtoFromJSONTyped(json, false);
}

export function RiskNoteMinimalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskNoteMinimalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
        'status': json['status'] == null ? undefined : json['status'],
        'type': json['type'] == null ? undefined : json['type'],
        'contractId': json['contractId'] == null ? undefined : json['contractId'],
    };
}

export function RiskNoteMinimalDtoToJSON(json: any): RiskNoteMinimalDto {
    return RiskNoteMinimalDtoToJSONTyped(json, false);
}

export function RiskNoteMinimalDtoToJSONTyped(value?: RiskNoteMinimalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'identifier': value['identifier'],
        'status': value['status'],
        'type': value['type'],
        'contractId': value['contractId'],
    };
}

